import { motion, useReducedMotion } from 'framer-motion';

// Tela de transição entre rotas públicas. Cobre a viewport inteira com a cor
// da marca para evitar o flash "metade branco, metade azul" do fallback antigo.
// O fade-in é atrasado de propósito: navegações rápidas terminam antes da tela
// aparecer, então nada pisca.
export default function RouteTransitionScreen() {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className="fixed inset-0 z-[90] flex flex-col items-center justify-center overflow-hidden bg-cdi-blue px-6 text-white"
      role="status"
      aria-live="polite"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: reduceMotion ? 0 : 0.15, ease: 'easeOut' }}
    >
      <div className="absolute left-0 top-0 h-2 w-24 bg-cdi-yellow" aria-hidden="true" />
      <div className="absolute bottom-0 right-0 h-14 w-14 bg-cdi-yellow" aria-hidden="true" />

      <div className="relative flex h-24 w-24 items-center justify-center" aria-hidden="true">
        <motion.div
          className="absolute inset-0 rounded-full border-2 border-cdi-yellow/25 border-t-cdi-yellow"
          animate={reduceMotion ? undefined : { rotate: 360 }}
          transition={reduceMotion ? undefined : { duration: 1, ease: 'linear', repeat: Infinity }}
        />
        <span className="text-xl font-black tracking-tight text-white">CDI</span>
      </div>

      <p className="mt-5 text-xs font-black uppercase tracking-[0.45em] text-cdi-yellow">Premium</p>

      <div className="mt-5 h-1 w-28 overflow-hidden bg-white/15" aria-hidden="true">
        <motion.div
          className="h-full w-1/2 bg-cdi-yellow"
          animate={reduceMotion ? undefined : { x: ['-100%', '200%'] }}
          transition={reduceMotion ? undefined : { duration: 1.1, ease: 'easeInOut', repeat: Infinity }}
        />
      </div>

      <span className="mt-4 text-[10px] font-black uppercase tracking-[0.22em] text-white/55">
        Carregando página
      </span>
    </motion.div>
  );
}
